import Link from 'next/link';
import styles from './TestEds.module.scss';

export const CspSetupLinux = () => {
    return (
        <div className={styles.container}>
            <div className={styles.panel}>
                <h1>Установка КриптоПРО CSP в Linux</h1>
                <p>
                    Описание процесса установки приведено на примере
                    дистрибутива семейства Debian (x64).
                    <br />
                    Некоторые команды могут потребовать запуска с{' '}
                    <code>sudo</code>.<br />
                    Названия файлов и директорий могут отличаться из-за различий
                    в версиях.
                </p>
                <p>
                    Загрузите
                    <a
                        href="https://www.cryptopro.ru/products/csp/downloads"
                        rel="nofollow noopener noreferrer"
                        target="_blank"
                    >
                        {' КриптоПро CSP '}
                    </a>
                    <mark>{' версии 4.0 '}</mark>
                    для Вашей платформы и распакуйте архив:
                </p>
                <pre>
                    <strong>tar -xzvf linux-amd64_deb.tgz</strong>
                </pre>
                <br />

                <p>Для установки выполните команды:</p>
                <pre>
                    <strong>
                        sudo chmod 777 -R linux-amd64_deb/ sudo
                        linux-amd64_deb/install.sh
                    </strong>
                </pre>
                <br />

                <p>
                    Проверьте <u>отсутствие</u> <code>cprocsp-rdr-gui</code>:
                </p>
                <pre>
                    <strong>dpkg -l | grep cprocsp-rdr</strong>
                </pre>
                <br />
                <p>
                    Установите дополнительно <code>cprocsp-rdr-gui-gtk</code>:
                </p>
                <pre>
                    <strong>
                        sudo dpkg -i
                        linux-amd64_deb/cprocsp-rdr-gui-gtk-64_4.0.0-4_amd64.deb
                    </strong>
                </pre>
                <br />

                <p>Установите лицензионный ключ командой:</p>
                <pre>
                    <strong>
                        sudo /opt/cprocsp/sbin/amd64/cpconfig -license -set
                        XXXXX-XXXXX-XXXXX-XXXXX-XXXXX
                    </strong>
                </pre>
                <br />
                <a
                    href="https://www.cryptopro.ru/faq/gde-vzyat-dokumentatsiyu-po-ustanovke-kakie-pakety-stavit"
                    rel="nofollow noopener noreferrer"
                    target="_blank"
                    title="Инструкции по установке от КриптоПро"
                >
                    Дополнительная информация по установке
                </a>
            </div>
        </div>
    );
};
